
import React from 'react';
import { preparePlayerConfig } from '../services/VideoPlayerService';
import { StyleSheet, css } from 'aphrodite/no-important';

class FsPlayer extends React.Component {
	constructor(props){
		super(props);
		this.state = {
			playerConfig: this.props.playerConfig,
		}
	}

	componentDidMount() {
	}

	componentWillUpdate() {
	}

	render(){

		let playerConfig = this.props.playerConfig

		if(playerConfig instanceof Object){
			playerConfig = preparePlayerConfig(playerConfig);
		}

		return (
			<div className="fs-player">
				<div className="platformPlayer-wrapper">
					<div ref={this.props.playerRef}
						 className={css(styles.playerStyles) + " fs-video-player"}
						 data-player-config={playerConfig}></div>
				</div>
			</div>
		);
	}

}

export default FsPlayer;


const styles = StyleSheet.create({
	playerStyles: {
		height: 'auto !important',
		width: '100% !important',
		paddingBottom: '56% !important',
		position: 'absolute'
	}
});


// WEBPACK FOOTER //
// ./react-app-src/shared/components/FsPlayer.js